import * as React from "react";
const SvgGroupLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeOpacity: 0.6, d: "M0 10h20" }));
export default SvgGroupLine;
